import FacebookImage from '@/components/base/social/FacebookImage';
import InstagramImage from '@/components/base/social/InstagramImage';
import YoutubeImage from '@/components/base/social/YoutubeImage';
import TwitterImage from '@/components/base/social/TwitterImage';
import LinkedInImage from '@/components/base/social/LinkedInImage';
import rawChannel from '@/components/base/channel/RawChannel';
import GoogleMyBusinessImage from '@/components/base/social/GoogleMyBusinessImage';
import GooglePlayImage from '@/components/base/social/GooglePlayImage';
import TikTokImage from '@/components/base/social/TikTokImage';
import BlipImage from '@/components/base/social/BlipImage';
import colors from '@/utils/colors';

const {
  instagramColor,
  facebookColor,
  youtubeColor,
  twitterColor,
  tumblrColor,
  blogsColor,
  forunsColor,
  comentariosemartigosColor,
  googleplayColor,
  googleplusColor,
  googlemybusinessColor,
  foursquareColor,
  buscapeColor,
  reclameaquiColor,
  linkedinColor,
  siteColor,
  tvColor,
  zapierColor,
  newsColor,
  notClassifiedColor,
  radioColor,
  impressasColor,
  portaisColor,
  tiktokColor,
  blipColor,
} = colors;

export const channelToComponent = {
  facebook: FacebookImage,
  instagram: InstagramImage,
  youtube: YoutubeImage,
  twitter: TwitterImage,
  linkedin: LinkedInImage,
  googlemybusiness: GoogleMyBusinessImage,
  googleplay: GooglePlayImage,
  tiktok: TikTokImage,
  blip: BlipImage,
};

const channelsColors = {
  // Colors
  instagramColor,
  instagramcommentsColor: instagramColor,
  facebookColor,
  facebookgroupsColor: facebookColor,
  facebookcommentsColor: facebookColor,
  facebookinboxColor: facebookColor,
  youtubeColor,
  youtubecommentsColor: youtubeColor,
  twitterColor,
  twitterinboxColor: twitterColor,
  tumblrColor,
  blogsColor,
  forunsColor,
  comentariosemartigosColor,
  googleplayColor,
  googleplusColor,
  googlemybusinessColor,
  foursquareColor,
  buscapeColor,
  reclameaquiColor,
  linkedinColor,
  linkedincommentsColor: linkedinColor,
  siteColor,
  tvColor,
  zapierColor,
  newsColor,
  notClassifiedColor,
  rádioColor: radioColor,
  boxnetradioColor: radioColor,
  impressasColor,
  boxnetprintednewsColor: impressasColor,
  portaisColor,
  tiktokColor,
  blipColor,
};

export const channelsLabels = {
  // Labels
  instagramLabel: 'Instagram',
  facebookLabel: 'Facebook',
  youtubeLabel: 'YouTube',
  twitterLabel: 'Twitter',
  tumblrLabel: 'Tumblr',
  comentariosemartigosLabel: 'Comentários em Artigos',
  blogsLabel: 'Blogs',
  forunsLabel: 'Fóruns',
  googleplayLabel: 'Google Play',
  googleplusLabel: 'Google Plus',
  googlemybusinessLabel: 'Google Meu Negócio',
  foursquareLabel: 'Foursquare',
  buscapeLabel: 'Avaliações de Produtos',
  reclameaquiLabel: 'Reclame Aqui',
  linkedinLabel: 'LinkedIn',
  siteLabel: 'Site',
  tvLabel: 'TV',
  zapierLabel: 'Zapier',
  newsLabel: 'Portais',
  notClassifiedLabel: 'Não Classificado',
  facebookgroupsLabel: 'Grupos no Facebook',
  facebookcommentsLabel: 'Comentários no Facebook',
  instagramcommentsLabel: 'Comentários no Instagram',
  youtubecommentsLabel: 'Comentários no YouTube',
  linkedincommentsLabel: 'Comentários no LinkedIn',
  twitterinboxLabel: 'Inbox do Twitter',
  facebookinboxLabel: 'Inbox do Facebook',
  portaisLabel: 'Portais',
  rádioLabel: 'Rádio',
  boxnetradioLabel: 'Rádio',
  impressasLabel: 'Impresso',
  boxnetprintednewsLabel: 'Impresso',
  tiktokLabel: 'TikTok',
  blipLabel: 'Blip',
  ImportedDataLabel: 'Dados Importados',
};

const channelsIcons = {
  // Icons
  instagramIcon: 'instagram',
  facebookIcon: 'facebook',
  youtubeIcon: 'youtube',
  twitterIcon: 'twitter',
  tumblrIcon: 'tumblr',
  comentariosemartigosIcon: 'chat-processing',
  blogsIcon: 'post',
  forunsIcon: 'message-reply-text',
  googleplayIcon: 'google-play',
  googleplusIcon: 'google-plus',
  googlemybusinessIcon: 'google-my-business',
  foursquareIcon: 'comment-edit-outline',
  buscapeIcon: 'thumbs-up-down',
  reclameaquiIcon: 'thumbs-up-down',
  linkedinIcon: 'linkedin',
  siteIcon: 'web',
  tvIcon: 'television-classic',
  zapierIcon: 'asterisk',
  newsIcon: 'newspaper-variant-multiple',
  notClassifiedIcon: 'frequently-asked-Questions',
  facebookgroupsIcon: 'facebook',
  facebookcommentsIcon: 'facebook',
  instagramcommentsIcon: 'instagram',
  youtubecommentsIcon: 'youtube',
  linkedincommentsIcon: 'linkedin',
  twitterinboxIcon: 'twitter',
  facebookinboxIcon: 'facebook',
  rádioIcon: 'television-classic',
  impressasIcon: 'television-classic',
  portaisIcon: 'television-classic',
  tiktokIcon: 'tiktok',
  blipIcon: 'blip',
  ImportedDataIcon: 'post',
};

export const channelObj = {
  ...channelsColors,
  ...channelsLabels,
  ...channelsIcons,
};

export const channels = [
  'instagram',
  'instagramcomments',
  'facebook',
  'facebookinbox',
  'facebookgroups',
  'facebookcomments',
  'youtube',
  'youtubecomments',
  'twitter',
  'twitterinbox',
  'tumblr',
  'news',
  'blogs',
  'foruns',
  'comentariosemartigos',
  'googleplay',
  'googleplus',
  'googlemybusiness',
  'foursquare',
  'buscape',
  'reclameaqui',
  'linkedin',
  'linkedincomments',
  'tv',
  'rádio',
  'impressas',
  'portais',
  'tiktok',
  'Blip',
  'ImportedData',
];

export const getChannelObj = (title) => {
  const prefix = title === 'notClassified' ? title : title.toLowerCase();

  return {
    color: channelObj[`${prefix}Color`],
    name: channelObj[`${prefix}Label`],
    icon: channelObj[`${prefix}Icon`],
  };
};

export const getChannelColorNameAndIcon = (title) => {
  const channel = title?.toLowerCase();
  const exceptions = {
    all: 'notClassified',
    feedly: 'blogs',
    googlemybusinessreviews: 'googlemybusiness',
    hardmob: 'foruns',
    disqus: 'comentariosemartigos',
    newscomments: 'news',
  };

  if (!channel) {
    return getChannelObj(exceptions.all);
  }

  if (!channels.includes(channel) && !Object.keys(exceptions).includes(channel)) {
    return getChannelObj(exceptions.all);
  }

  return getChannelObj(exceptions[channel] || channel);
};

export const findSocialIcon = channel => channelToComponent[channel.toLowerCase()] || rawChannel;

export const formatTitleAndChannel = ({ username, title, channel }) => `${title || username} (${channel})`;

export const isGMB = channel => channel.toLowerCase() === 'googlemybusiness';
export const isInstagram = channel => channel.toLowerCase() === 'instagram';
export const isTikTok = channel => channel.toLowerCase() === 'tiktok';

export const channelsRegex = /Label/u;

export function getTranslatedChannels() {
  return Object.fromEntries(Object.entries(channelsLabels).map(([key, value]) => {
    const newKey = key.replace(channelsRegex, '');
    return [newKey, value];
  }));
}
